import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DataMatrix from 'react-datamatrix-svg';
import { selectCurrentPartOrder } from 'store/slices/activeContentSlice';
import { PackageOrder } from 'app/models/PackageOrder';
import { parsePackageEntryName } from 'app/containers/OrderDetails/PackagesTab/index';
import { selectAllColors } from 'store/slices/colorSlice';

interface PackagesQRCodesPageProps {
  columns?: number;
}

const PackagesQRCodesPage: React.FC<PackagesQRCodesPageProps> = ({
  columns = 5,
}) => {
  // Get orderId from URL
  const { orderId } = useParams<{ orderId: string }>();
  // Get partOrder from redux (selector already filters by current order)
  const partOrder = useSelector(selectCurrentPartOrder());
  const allColors = useSelector(selectAllColors);

  if (!(partOrder && (partOrder as any).packages)) {
    return <div>Chargement des colis...</div>;
  }

  const gridClass = `grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${columns} gap-8`;

  return (
    <div className="container mx-auto py-8">
      <h1 className="text-2xl font-bold mb-6 text-center">
        QR codes DataMatrix des colis de la commande {orderId}
      </h1>
      <div className={gridClass}>
        {(partOrder as any).packages.map((pkg: PackageOrder) => (
          <div
            key={pkg.id}
            className="flex flex-col items-center border rounded-lg p-6 shadow bg-white"
          >
            <DataMatrix msg={`${pkg.id}`} dim={180} pal={['#000', '#fff']} />
            <div className="mt-4 text-lg font-semibold text-center">
              {pkg.uniqueDescr
                ? pkg.uniqueDescr
                : pkg.name
                ? parsePackageEntryName(pkg.name, allColors as any)
                : `Colis ${pkg.id}`}
            </div>
            <div className="mt-2 text-gray-500">ID: {pkg.id}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackagesQRCodesPage;
